import { createStore } from 'zustand/vanilla';
const INITIAL_STATE = {
    modals: new Map(),
    stack: new Set(),
};
export const createModalStore = (opts) => {
    const storeCreator = (set, get) => ({
        ...INITIAL_STATE,
        resetStore: () => {
            set((prev) => ({ ...prev, ...INITIAL_STATE }));
        },
        resetModals: () => {
            get()
                .getModalIds()
                .forEach((id) => get().updateModal({ id, status: 'exiting' }));
        },
        generateId: opts.generateId,
        addModal: (opts) => {
            const id = get().generateId();
            const onClose = () => get().updateModal({ id, status: 'exiting' });
            const modalState = {
                id,
                modal: opts.modal,
                status: 'open',
                userClose: opts.props.onClose,
                inheritScope: opts.inheritScope,
                props: {
                    ...opts.props,
                    onClose,
                },
            };
            const updatedMap = new Map(get().modals);
            updatedMap.set(id, modalState);
            const updatedStack = new Set(get().stack);
            updatedStack.add(id);
            set((prev) => ({ ...prev, modals: updatedMap, stack: updatedStack }));
            return modalState;
        },
        getModalById: (opts) => {
            return get().modals.get(opts.id) || null;
        },
        getModalIds: () => {
            return Array.from(get().modals.keys());
        },
        updateModal: (opts) => {
            const modal = get().modals.get(opts.id);
            if (!modal) {
                return null;
            }
            const updatedModal = {
                ...modal,
                status: opts.status ?? modal.status,
                userClose: opts.props?.onClose ?? modal.userClose,
                props: {
                    ...modal.props,
                    ...opts.props,
                    onClose: modal.props.onClose,
                },
            };
            const updatedMap = new Map(get().modals);
            updatedMap.set(opts.id, updatedModal);
            set((prev) => ({ ...prev, modals: updatedMap }));
            return updatedModal;
        },
        removeModal: (opts) => {
            const modal = get().modals.get(opts.id);
            if (!modal) {
                return null;
            }
            const updatedMap = new Map(get().modals);
            updatedMap.delete(opts.id);
            const updatedStack = new Set(get().stack);
            updatedStack.delete(opts.id);
            set((prev) => ({ ...prev, modals: updatedMap, stack: updatedStack }));
            modal.userClose?.();
            return modal;
        },
    });
    return createStore()(storeCreator);
};
//# sourceMappingURL=createModalStore.js.map